import moment from "moment";
import { InputLabel } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

import {
  useGetDigitalCourseIdsByBu,
  dispatchIdDropdown,
  initialFilterForm,
} from "../../dlpStockIssuance/dispatchSchedule/constant";
import ALoader from "views/pages/manage/common/a-loader";
import AButton from "../../../../common/form-fields-mui/AButton";
import SelectMaterialElasticSearch from "../../mastersAndMapping/onBoardingMaterialIdSetup/SelectMaterialElasticSearch";
import { InputLabelStyle } from "../../../../common/form-fields-mui/ASelect";
import CustomDatePicker from "../../../../common/commonComponents/CustomDatePicker";
import { getFilterCount } from "../../mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { STATUS_DROPDOWN } from "../../../constant/batch-search";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";

const SearchFilterForm = ({
  dropdown,
  closeForm,
  filterCount,
  filterPayload,
  applyFilter = () => {},
}) => {
  const [filterForm, setFilterForm] = useState(filterPayload);
  const filterFormHandler = (value, key) =>
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  const [courseIdDropdown, isFetching] = useGetDigitalCourseIdsByBu(filterForm);

  useEffect(() => {
    setFilterForm(filterPayload);
  }, [filterPayload]);

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      {isFetching && <ALoader />}
      <CardBody className="d-flex flex-column">
        <div className="mb-1 d-flex align-items-start justify-content-between">
          <div className="regular-large-bold">Filter by</div>
        </div>
        <div className="d-flex flex-column gap-md">
          <AAutoComplete
            label="Dispatch ID"
            currentValue={filterForm?.dispatchId}
            items={dispatchIdDropdown}
            handleChange={(value) => {
              filterFormHandler(value, "dispatchId");
            }}
            isMulti={false}
          />

          <AAutoComplete
            label="Business area"
            currentValue={filterForm?.businessArea}
            items={dropdown?.businessArea}
            handleChange={(value) => {
              filterFormHandler(value, "businessArea");
            }}
            isMulti={false}
          />

          <AAutoComplete
            label="Course ID"
            currentValue={filterForm?.courseId}
            items={courseIdDropdown}
            handleChange={(value) => {
              filterFormHandler(value, "courseId");
            }}
            isMulti={false}
          />

          <AAutoComplete
            label="Term"
            currentValue={filterForm?.term}
            items={dropdown?.term}
            handleChange={(value) => {
              filterFormHandler(value, "term");
            }}
            isMulti={false}
          />

          <AAutoComplete
            label="Academic group"
            currentValue={filterForm?.academicGroup}
            items={dropdown?.academicGroup}
            handleChange={(value) => {
              filterFormHandler(value, "academicGroup");
            }}
            isMulti={false}
          />

          <SelectMaterialElasticSearch
            label="Material details"
            currentValue={filterForm?.materialNumber}
            handleChange={(value) => filterFormHandler(value, "materialNumber")}
            isMulti={false}
            dropdownMappingParams={[
              "materialIdAndDescription",
              "materialId",
              "materialDescription",
            ]}
            isDlpSearch
          />

          <div>
            <InputLabel style={InputLabelStyle}>
              Schedule date from-to
            </InputLabel>
            <Row>
              <Col sm="6">
                <CustomDatePicker
                  placeHolder="Select"
                  // maxDate={moment()}
                  value={
                    filterForm?.scheduleDateFrom
                      ? moment(filterForm?.scheduleDateFrom)
                      : null
                  }
                  handler={(index, date, keyName) => {
                    filterFormHandler(date, "scheduleDateFrom");
                  }}
                />
              </Col>
              <Col sm="6">
                <CustomDatePicker
                  placeHolder="Select"
                  value={
                    filterForm?.scheduleDateTo
                      ? moment(filterForm?.scheduleDateTo)
                      : null
                  }
                  handler={(index, date, keyName) => {
                    filterFormHandler(date, "scheduleDateTo");
                  }}
                  minDate={moment(filterForm?.scheduleDateFrom)}
                  disabled={!filterForm?.scheduleDateFrom}
                />
              </Col>
            </Row>
          </div>

          <AAutoComplete
            label="Status"
            currentValue={filterForm?.status}
            items={STATUS_DROPDOWN}
            handleChange={(value) => {
              filterFormHandler(value, "status");
            }}
            isMulti={false}
          />
        </div>

        <div className="mt-3 d-flex flex-row-reverse justify-content-between">
          <AButton
            variant="primary_filled"
            className="button_remove_left_margin"
            onClick={() => {
              closeForm();
              applyFilter(filterForm);
            }}
            disabled={!getFilterCount(filterForm)}
          >
            Apply filter
          </AButton>
          {filterCount > 0 && (
            <AButton
              variant="outline"
              className="button_remove_left_margin"
              updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
              onClick={() => {
                closeForm();
                applyFilter(initialFilterForm);
              }}
            >
              Remove filter
            </AButton>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default SearchFilterForm;
